<template>
    <span :class="classComputed"> <slot /> </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    colorStyle: {
        type: String,
        default: 'gray',
    },
});

const classComputed = computed(() => {
    return {
        'inline-flex items-center px-2 py-0.5 rounded text-sm font-medium whitespace-nowrap': true,
        'bg-gray-200 text-gray-800': props.colorStyle === 'gray',
        'bg-yellow-500 text-white': props.colorStyle === 'yellow',
    };
});
</script>
